import React from 'react';
import { MATERIAL_ROW_COUNT } from '../fieldNames';

const headerCell = 'text-xs uppercase tracking-wide text-pvs-text-muted text-left px-3 py-2';
const bodyCell = 'px-2 py-2';

const MaterialsSection = ({ rows, update }) => (
  <section className="pvs-glass p-6 mb-6">
    <header className="mb-4">
      <h2 className="text-xl font-semibold text-white">Materials Used On Site</h2>
      <p className="text-sm text-pvs-text-muted mt-1">Log any parts consumed during the examination (up to {MATERIAL_ROW_COUNT} rows).</p>
    </header>
    <div className="overflow-x-auto">
      <table className="min-w-full">
        <thead>
          <tr>
            <th className={headerCell}>Code</th>
            <th className={headerCell}>Description</th>
            <th className={headerCell}>Qty</th>
            <th className={headerCell}>Replenish</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx} className="border-t border-pvs-border">
              <td className={bodyCell}>
                <input
                  className="pvs-input w-full"
                  value={row.code || ''}
                  onChange={(e) => update(idx, 'code', e.target.value)}
                />
              </td>
              <td className={bodyCell}>
                <input
                  className="pvs-input w-full"
                  value={row.description || ''}
                  onChange={(e) => update(idx, 'description', e.target.value)}
                />
              </td>
              <td className={bodyCell}>
                <input
                  className="pvs-input w-full"
                  value={row.quantity || ''}
                  onChange={(e) => update(idx, 'quantity', e.target.value)}
                />
              </td>
              <td className={bodyCell}>
                <input
                  className="pvs-input w-full"
                  value={row.replenish || ''}
                  onChange={(e) => update(idx, 'replenish', e.target.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);

export default MaterialsSection;
